<template>

  <div id="passwordInput">
    <p class="text-sm-center fontSize14 mb30 mbXxs40 mbMd50">新しいパスワードを入力してください。</p>
    <!-- / -->
    <b-form name="formPasswordChange"
            v-bind:action="propsPageUrl"
            method="POST">
      <!-- nonce / -->
      <input type="hidden" id="_wpnonce" name="_wpnonce" v-bind:value="propsWpNonce" />
      <input type="hidden" name="_wp_http_referer" v-bind:value="propsPageUrl" />
      <!-- / nonce -->
      <!-- param / -->
      <input type="hidden" name="password_reset_session" v-bind:value="propsSession">
      <input type="hidden" name="email" v-bind:value="propsEmail">
      <!-- / param -->
      <div class="memberInfoBox mb30 mbMd20 pxMd20">
        <dl class="d-md-flex align-items-center mb0">
          <dt class="memberInfoTtl iconMemberPassword mb5 mbMd0">新しいパスワード</dt>
          <!-- / -->
          <dd class="memberInfoData">
            <b-form-input v-validate="{
                            required:true,
                            alpha_dash:true,
                            min:6,
                            max:18
                          }"
                          v-model.trim="form.password"
                          type="password"
                          name="password"
                          ref="password"
                          data-vv-as="パスワード"
                          class="textBox">
            </b-form-input>
          </dd>
          <!-- / -->
        </dl>
        <!-- / -->
        <ul class="listAttention noticeBox mt5 mb0">
          <li>6～18文字以下でご入力ください。</li>
          <li>半角英数字と記号('-','_')が使用できます。</li>
        </ul>
        <!-- / -->
        <div v-if="veeErrors.first('password')" class="errMsgBox noticeBox mt10">
          <p class="errMsg">{{veeErrors.first('password')}}</p>
        </div>
        <!-- / -->
      </div>
      <!-- / -->
      <div class="memberInfoBox pxMd20">
        <dl class="d-md-flex align-items-center mb0">
          <dt class="memberInfoTtl iconMemberPassword mb5 mbMd0">新しいパスワード<br class="d-none d-md-inline">（再入力）</dt>
          <!-- / -->
          <dd class="memberInfoData">
            <b-form-input v-validate="{required:true,confirmed:'password'}"
                          v-model.trim="form.password_confirm"
                          type="password"
                          name="password_confirm"
                          class="textBox"
                          data-vv-as="パスワード（再入力）">
            </b-form-input>
          </dd>
          <!-- / -->
        </dl>
        <!-- / -->
        <div v-if="veeErrors.first('password_confirm')" class="errMsgBox noticeBox mt10">
          <p class="errMsg">{{veeErrors.first('password_confirm')}}</p>
        </div>
        <!-- / -->
      </div>
      <!-- / -->
      <div class="text-center mt40 mtXxs50 mtMd60">
        <b-button v-bind:disabled="veeErrors.any() || !form.password || !form.password_confirm"
                  type="submit"
                  id="btnChangePassword"
                  variant="outline-primary"
                  class="btnProcedure">
                  変更する<i class="fa fa-angle-right ml-3"></i>
        </b-button>
      </div>
      <!-- / -->
    </b-form>
    <!-- /formPasswordChange -->
  </div>

</template>


<style scoped>
  input[type="password"] {
    height: 50px;
  }
</style>


<script>
    //import mixin
    import common from '../../../mixins/common';

    //vue
    export default {
        mixins: [common],
        props: {
          propsPageUrl: {
            type: String
          },
          propsWpNonce: {
            type: String
          },
          propsSession: {
            type: String
          },
          propsEmail: {
            type: String
          }
        },
        data: function() {
          return {
            form: {
              password: null,
              password_confirm: null
            }
          };
        },
        mounted() {
            console.log('PasswordResetFormComponent mounted.')
        }
    }
</script>
